<template>
  <div class="tab-container">
    <div class="tabs">
      <div
        v-for="(item, index) in tabs"
        :key="item.id || index"
        class="tab-item"
        :class="{
          active: defaultActive == item.id,
          lastChild: index == tabs.length - 1,
        }"
        @click="handleTabClick(item, index)"
      >
        <el-badge
          :hidden="item.count == 0"
          v-show="isRed == 1 || isRed == 2"
          :value="item.count"
          :max="99"
          :class="isRed == 1 ? 'item' : 'item2'"
        >
          {{ item.name }}
        </el-badge>
        <span v-show="isRed == 0">{{ item.name }}</span>
      </div>
      <!-- 刷新图标，只有在我的订阅的时候才需要展示 -->
      <svg-btn
        @click="refreshBt"
        v-if="$route.name == 'home'"
        class="refresh"
        icon-class="icon-gfans-refresh"
      ></svg-btn>
      <div
        class="tab-indicator"
        :style="{ left: indicatorLeft, width: indicatorWidth }"
      ></div>
    </div>
    <div class="clearBox" @click="collectUp" v-show="$route.name == 'collect'">
      <div class="clearF">一键已读</div>
      <svg-btn class="icon" icon-class="icon-gfans-clear"></svg-btn>
    </div>
  </div>
</template>

<script>
import { checkCollect } from '@/axios/collect'
import { eventBus } from '@/utils/event-bus'
export default {
  name: 'TabCheck',
  props: {
    tabs: {
      type: Array,
      default: [],
    },
    defaultActive: {
      type: [String, Number],
      default: 0,
    },
    isRed: {
      type: Number,
      default: 0, //0不显示 1显示红色 2显示主题色
    },
  },
  data() {
    return {
      indicatorLeft: '0px',
      indicatorWidth: '0px',
      indicatorOffset: 2, // 左右各偏移2px，总共宽4px
    }
  },
  mounted() {
    this.updateIndicator()
  },
  watch: {
    defaultActive() {
      this.updateIndicator()
    },
    tabs: {
      handler() {
        this.updateIndicator()
      },
      deep: true,
    },
  },
  methods: {
    //收藏一键已读
    collectUp: _.debounce(
      function () {
        checkCollect()
          .then(res => {
            if (res.status == 1) {
              eventBus.$emit('getCollect')
              eventBus.$emit('appReload')
              this.$toast(res.msg, 1)
            }
          })
          .catch(error => {})
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //发现页面点击刷新按钮
    refreshBt() {
      this.$emit('refresh-change')
    },
    handleTabClick(tab, index) {
      if (this.$store.state.isLogin == 0 && this.$route.name != 'home') {
        eventBus.$emit('showLogin', {})
        return
      }
      if (
        this.defaultActive == tab.id &&
        this.$route.name != 'home' &&
        this.$route.name != 'subscribe'
      ) {
        return
      }
      // this.defaultActive = tab.id
      this.$emit('tab-change', tab.id)
    },
    updateIndicator() {
      this.$nextTick(() => {
        const activeTab = this.$el.querySelector('.tab-item.active')

        if (activeTab) {
          const tabsRect = this.$el.getBoundingClientRect()
          const activeRect = activeTab.getBoundingClientRect()

          // 计算指示器位置和宽度（左右各偏移2px）
          this.indicatorLeft = `${
            activeRect.left - tabsRect.left - this.indicatorOffset
          }px`
          this.indicatorWidth = `${
            activeRect.width + this.indicatorOffset * 2
          }px`
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
